import { initializeApp, getApps, getApp } from "firebase/app";
import { initializeFirestore, getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import firebaseConfig from "../../../fb.json";

export const app = getApps().length ? getApp() : initializeApp(firebaseConfig);
// Safari (and some corporate networks) choke on Firestore's WebChannel streams;
// force long-polling to avoid 60 s hangs waiting for WebChannel to time out.
export const db = getApps().length
  ? getFirestore(app)
  : initializeFirestore(app, { experimentalForceLongPolling: true });
export const storage = getStorage(app);
